import React from 'react';
import { motion } from 'framer-motion';
import { PanelLeft, PanelRight, Users, Package } from 'lucide-react';
import { CONSTANTS } from '../../data';

interface PanelToggleButtonProps {
  side: 'left' | 'right';
  isOpen: boolean;
  onToggle: () => void;
  panelWidth: number;
  isLargeScreen: boolean;
  touchFeedback: boolean;
}

const PanelToggleButton: React.FC<PanelToggleButtonProps> = ({
  side,
  isOpen,
  onToggle,
  panelWidth,
  isLargeScreen,
  touchFeedback,
}) => {
  const panelTransition = { type: "tween", ease: "easeInOut", duration: 0.3 };
  const IconOpen = side === 'left' ? PanelLeft : PanelRight;
  const IconClosed = side === 'left' ? Package : Users;
  const title = isOpen
    ? `Close ${side === 'left' ? 'Inventory' : 'Queue'}`
    : `Open ${side === 'left' ? 'Inventory' : 'Queue'}`;

  const animationProps = side === 'left'
    ? { left: isLargeScreen && isOpen ? panelWidth + 16 : 16 }
    : { right: isLargeScreen && isOpen ? panelWidth + 16 : 16 };

  return (
    <motion.button
      onClick={onToggle}
      className={`absolute top-1/2 -translate-y-1/2 z-30 bg-surface p-3 rounded-full shadow-lg hover:bg-primary-action hover:text-white transition-all active:scale-95 flex items-center justify-center ${
        touchFeedback ? 'ring-2 ring-primary-action/50' : ''
      }`}
      title={title}
      animate={animationProps}
      transition={panelTransition}
      style={{
        minHeight: `${Math.max(48, CONSTANTS.TOUCH_INTERACTION.MIN_TOUCH_TARGET_SIZE)}px`,
        minWidth: `${Math.max(48, CONSTANTS.TOUCH_INTERACTION.MIN_TOUCH_TARGET_SIZE)}px`,
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      {isOpen ? <IconOpen size={20} /> : <IconClosed size={20} />}
    </motion.button>
  );
};

export default PanelToggleButton;
